<!-- ---TEMPLATE--- -->
<template>
  <div>
    <el-row>
      <!-- the row, going to repeat -->
      <el-col :span="24" class="rowSpan24" id="newsFontSizeChange">
        <el-col :span="20">
          <div class="menuParent" >
            <div class="menuTitle"  v-for="(set,index) in groups" v-bind:key="index">
              <div class="newsTitle" v-on:click="set.open = !set.open" id="newdsId">雑誌({{getMagazineCount}}件)</div>
            </div>
           </div>
        </el-col>
        <el-col :span="4">
          <div class="menuParent2">
          </div>
        </el-col>
        <div class="toolTipDiv" id="toolTipDiv">
          <el-tooltip class="ToolTipItem" effect="dark" placement="bottom-end">
            <div class="display-size" slot="content">
              <ul>
                <li>
                  <span>小</span>
                </li>
                <li>
                  <span>中</span>
                </li>
                <li >
                  <span>大</span>
                </li>
              </ul>
            </div>
            
          </el-tooltip>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="accord">
          <div v-for="(set,index) in groups" v-bind:key="index">
           <div id="anim">
              <transition name="slide">
                <el-collapse-transition>
                  <div v-show="set.open">
                    <div v-for="(item,index) in set.items" v-bind:key="index">
                      <DraggableMagazineArticle0013 v-bind:articleList="getMagazineArticles"/>
                      
                    </div>
                  </div>
                </el-collapse-transition>
              </transition>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
 
<!-- --SCRIPT--- -->
<script>
import { mapGetters } from "vuex";
import DraggableMagazineArticle0013 from "./DraggableMagazineArticle0013.vue";

 
export default {
  components: {
    DraggableMagazineArticle0013
  },
  data() {
    return {
      groups: {
        "group 1": {
          name: "Menu 1",
          open: "false",
          items: ["item1"]
        }
      },
    };
  },
  methods: {
  },
  computed: {
    ...mapGetters("situation0013",["getMagazineArticles","getMagazineCount"]),
  },
};
</script>
 
<!-- --STYLE--- -->
<style>
@import "../../assets/css/style.css";
 
/* element ui default classes start*/
.ico_sort_up {
  background: url("../../assets/image/ico_sort_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}
.ico_sort_up:hover {
  background: url("../../assets/image/ico_sort_over.svg") no-repeat;
}
.ico_sort_up:focus {
  background: url("../../assets/image/ico_sort_down.svg") no-repeat;
  outline: none;
}
 
/* print icon  */
.ico_print_up {
  background: url("../../assets/image/ico_print_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}
.ico_print_up:hover {
  background: url("../../assets/image/ico_print_over.svg") no-repeat;
}
.ico_print_up:focus {
  background: url("../../assets/image/ico_print_down.svg") no-repeat;
  outline: none;
}
 
/* batch-display icon */
.ico_batch-display_up {
  background: url("../../assets/image/ico_batch-display_up.svg") no-repeat;
  width: 16.57px;
  height: 22px;
}
.ico_batch-display_up:hover {
  background: url("../../assets/image/ico_batch-display_over.svg") no-repeat;
}
.ico_batch-display_up:focus {
  background: url("../../assets/image/ico_batch-display_down.svg") no-repeat;
  outline: none;
}
 
/* csv-output icon */
.ico_csv-output_up {
  background: url("../../assets/image/ico_csv-output_up.svg") no-repeat;
  width: 19.21px;
  height: 22px;
}
.ico_csv-output_up:hover {
  background: url("../../assets/image/ico_csv-output_over.svg") no-repeat;
}
.ico_csv-output_up:focus {
  background: url("../../assets/image/ico_csv-output_down.svg") no-repeat;
  outline: none;
}
 
/* read-all-articles icon */
.ico_read-all-articles_up {
  background: url("../../assets/image/ico_read-all-articles_up.svg") no-repeat;
  width: 22px;
  height: 22px;
}
.ico_read-all-articles_up:hover {
  background: url("../../assets/image/ico_read-all-articles_over.svg") no-repeat;
}
.ico_read-all-articles_up:focus {
  background: url("../../assets/image/ico_read-all-articles_down.svg") no-repeat;
  outline: none;
}
 
.checkList .el-checkbox__inner {
  width: var(--checkBoxWidth);
  height: var(--checkBoxHeight);
  border: 2px solid #0097e0 !important;
  border-radius: 4px;
}
.checkList.is-checked .el-checkbox__inner::after {
  height: 10px;
  left: 5.9px;
  top: 1px;
  border-right-width: 2px;
  border-bottom-width: 2px;
  width: 5px;
}
.el-popover.el-popper .el-form .el-form-item .el-form-item__label {
  font-size: 9.6pt;
  padding-right: 8px !important;
  width: 48px;
}
.el-popover.el-popper .el-form .el-row {
  display: -webkit-box;
}
.el-input__suffix {
  right: 2px !important;
}
.el-input__inner {
  padding: 6px !important;
}
.el-icon-arrow-up:before {
  content: "\e6e1";
  font-size: 18px;
  text-shadow: 0px 0px 0.7px var(--grayDark);
}
.el-scrollbar
  > .el-select-dropdown__wrap.el-scrollbar__wrap
  > .el-select-dropdown__list {
  padding: 0px !important;
  background: var(--white) !important;
}
 
.el-scrollbar {
  overflow: hidden;
  position: relative;
  margin-top: -12px;
  width: 100% !important;
  box-shadow: 4px 3px 7px 0 rgba(0, 0, 0, 0.2) !important;
  border: 1px solid var(--grayLight);
  border-radius: 4px;
  background: var(--white);
}
.el-select-dropdown {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}
 
.el-popover.el-popper[x-placement^="bottom"] {
  margin-top: 4px !important;
  margin-left: -11px !important;
  width: 271px !important;
}
.el-popover {
  padding: 0px 8px 8px 8px !important;
}
 
.el-button.el-button--default.el-popover__reference span {
  display: block;
  background: transparent;
}
 
#newsFontSizeChange >>> .el-button {
  padding: 0px !important;
  margin: 0px !important;
}
 
/* element ui default classes end*/
/* -------------------------------------------------------------------------- */
/* custom css */
 
.dateSelect
  > .el-input.el-input--suffix.is-focus
  > .el-input__suffix
  > .el-input__suffix-inner {
  margin-right: 2px;
}
.dateSelect
  > .el-input.el-input--suffix
  > .el-input__suffix
  > .el-input__suffix-inner {
  margin-right: 2px;
}
.heading
  > .el-input.el-input--suffix.is-focus
  > .el-input__suffix
  > .el-input__suffix-inner {
  margin-right: 2px;
}
.heading
  > .el-input.el-input--suffix
  > .el-input__suffix
  > .el-input__suffix-inner {
  margin-right: 2px;
}
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.dateSelect
  .el-input {
  width: 164px;
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.dateSelect {
  width: 164px;
  margin-top: 16px;
}
.drop1 .el-select-dropdown__item.dateOption span {
  position: relative;
  display: block;
  top: 50%;
  transform: translateY(-50%);
}
.drop1 .el-select-dropdown__item.dateOption:first-child {
  margin-top: 3px;
}
.drop1 .el-select-dropdown__item.dateOption {
  height: 23px;
  margin-bottom: 3px;
}
.drop2 .el-select-dropdown__item.headingOption span {
  position: relative;
  display: block;
  top: 50%;
  transform: translateY(-50%);
}
.drop2 .el-select-dropdown__item.headingOption:first-child {
  margin-top: 3px;
}
.drop2 .el-select-dropdown__item.headingOption {
  height: 23px;
  margin-bottom: 3px;
}
.drop1 .el-select-dropdown__item.dateOption:hover {
  background-color: var(--selectHover) !important;
}
.drop2 .el-select-dropdown__item.headingOption:hover {
  background-color: var(--selectHover) !important;
}
 
.toolTipTop {
  width: 17px;
  position: absolute;
  left: 18px;
}
.sortIconImage {
  margin-left: 1px;
}
.selectForm > .el-form-item.dateSelectLable > .el-form-item__label {
  margin-top: 15px;
  margin-left: 30px;
}
.selectForm > .el-form-item.headingLable > .el-form-item__label {
  margin-top: 7px;
  margin-left: 30px;
}
 
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.dateSelect
  > .el-input.el-input--suffix
  > .el-input__inner {
  height: 35px !important;
  border: 1px solid var(--grayLight);
}
.selectForm > .el-form-item > .el-form-item__content > .el-select.heading {
  margin-top: 7px;
  width: 164px;
}
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.heading
  .el-input {
  width: 164px;
}
.selectForm
  > .el-form-item
  > .el-form-item__content
  > .el-select.heading
  > .el-input.el-input--suffix
  > .el-input__inner {
  height: 35px !important;
  border: 1px solid var(--grayLight);
}
 
/* cancel button  */
.el-row.is-justify-space-between.el-row--flex .roundGrayDark {
  background: var(--white);
  color: var(--grayDark);
  border: 1px solid var(--grayDark2);
  padding: 0px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundGrayDark:hover {
  background: var(--grayDark2);
  color: var(--white);
  border: 1px solid var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGrayDark:focus {
  background: var(--grayDark);
  color: var(--white);
  border: 1px solid var(--grayDark);
}
.el-row.is-justify-space-between.el-row--flex .el-row .roundGrayDark span {
  display: block;
  margin: 8px 11px 8px 11px;
}
 
/* reset button  */
.el-row.is-justify-space-between.el-row--flex .roundGray {
  background: var(--grayDark2);
  color: var(--white);
  border: 1px solid var(--grayDark2);
  margin-top: 12px !important;
  padding: 0px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundGray:hover {
  background: var(--white);
  border: 1px solid var(--grayDark2);
  color: var(--grayDark2);
}
.el-row.is-justify-space-between.el-row--flex .roundGray:focus {
  background: var(--grayDark);
  border: 1px solid var(--grayDark);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundGray span {
  display: block;
  margin: 2px 11px 2px 11px;
}
/* Okay button  */
.el-row.is-justify-space-between.el-row--flex .roundBlue {
  background: var(--selectOption);
  color: var(--secondary);
  border: 1px solid var(--secondary);
  margin-left: 8px !important;
  padding: 0px !important;
}
.el-row.is-justify-space-between.el-row--flex .roundBlue:hover {
  background: var(--secondary);
  border: 1px solid var(--secondary);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundBlue:focus {
  background: var(--okayFocused);
  border: 1px solid var(--okayFocused);
  color: var(--white);
}
.el-row.is-justify-space-between.el-row--flex .roundBlue span {
  display: block;
  margin: 8px 24px 8px 24px;
}
 
.menu_grps {
  background-color: #bfaeab;
  font-size: 18px;
  display: inline;
}
#anim {
  overflow-y: hidden;
  width: 100%;
}
 
.accord {
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}
.rotate {
  -moz-transition: all 0.2s;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.rotate.down {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  transform: translate(-49%, -198%);
  position: absolute;
  margin: 8px -2px 4px 0px;
}
.selectList {
  height: 13pt;
}
.arrowRotate {
  color: var(--secondary);
  font-size: 18px;
  float: right;
  top: 50%;
  position: relative;
  transform: rotate(90deg) translate(-194%, 79%);
  margin: 8px -6px 4px 0px;
  font-weight: bold !important;
  position: absolute;
  right: 0;
  top: 38px;
}
.displaySizeLarge {
  display: inline-block;
  height: 100%;
  width: 100%;
}
.displaySizeLarge div span {
  display: block;
  position: relative;
  top: 50%;
  transform: translateY(-6px) translateX(18px);
}
.displaySizeLarge div {
  font-size: 8pt;
  float: left;
  height: 100%;
  position: relative;
  top: 50%;
  height: 15pt;
  transform: translate(19%, -50%);
  cursor: pointer;
}
.menuLable .selectList,
.menuLable .printfile,
.menuLable .fileDetail,
.menuLable .csvFile,
.menuLable .selectAll {
  position: relative;
  top: 50%;
  transform: translateY(-5px);
  line-height: 10px;
}
.menuLable div {
  font-size: 8pt;
      position: relative;
    top: 50%;
    transform: translateY(-50%);
}
.selectAll {
  margin-left: 4px;
  margin-top: 1px;
  height: 10pt !important;
}
.printfile {
  margin-left: 4px !important;
}
.fileDetail {
  margin-left: 4px !important;
      margin-top: -1px;
}
.printfile,
.fileDetail {
  margin-left: 30px;
  margin-right: 16px;
  height: 10pt !important;
}
.csvFile {
  margin-left: 4px !important;
  height: 10pt !important;
  margin-top: -1px;
}
 
.strip::after {
  content: "";
  height: 28px;
  width: 2px;
  background-color: var(--grayLight);
  display: block;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: 0px 8px;
}
.rowSpan24 {
  border: 1px solid var(--primary);
  border-radius: 4px 4px;
  display: flex;
      height: 36px;
}
.menuParent2 {
  display: block;
  height: 100%;
}
.checkList {
  width: var(--checkBoxWidth);
  height: var(--checkBoxHeight);
  margin: auto 4px auto 8px !important;
}
.newsTitle {
  margin: 0px 10px;
  text-align: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
 
.menuLable {
  display: flex;
}
.menuLable label {
  padding-left: 0px !important;
}
 
.menuTitle {
  font-size: 9.6pt;
  font-weight: bold;
  color: var(--white);
  background-color: var(--primary);
  min-width: 188px;
  cursor: pointer;
  height: 100%;
}
.sortIcon .el-button:hover {
  background: transparent;
}
.sortIcon .el-button {
  border: none !important;
  background: transparent;
  padding: 0px !important;
  margin-top: 0px;
}
.sortIcon .el-button span {
  border: none !important;
  background: transparent;
}

.menuParent {
  list-style: none;
  display: -webkit-inline-box;
  width: 100%;
  vertical-align: bottom;
  height: 34px;
}
.el-dropdown-link {
  cursor: pointer;
  margin-left: 5px;
}
.button {
  margin-top: 35px;
}
 
.flip-list-move {
  transition: transform 0.5s;
}
 
.no-move {
  transition: transform 0s;
}
 
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
 
.list-group {
  min-height: 20px;
  list-style: none;
}
 
.list-group-item {
  cursor: move;
  font-size: 21px;
  background: #f4f4f4;
  margin: 10px 0px;
  padding: 10px;
  border: 1px solid #e4e4e4;
}
 
.list-group-item i {
  cursor: pointer;
}
 
/* Tooltip */
.display-size ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
}
 
.customStyle .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0097e0 !important;
  border-color: #0097e0 !important;
}
 
.el-tooltip__popper.is-dark {
  background: #ffffff !important;
  border: 1px solid #a2a4aa !important;
  border-radius: 4px !important;
}
 
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #ffffff !important;
}
 
.el-tooltip__popper .display-size ul li:nth-child(1) {
  border-radius: 4px 4px 0px 0px;
}
 
.el-tooltip__popper .display-size ul li:nth-child(3) {
  border-radius: 0px 0px 4px 4px;
}
 
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #a2a4aa !important;
}
.toolTipDiv {
  font-size: 8pt;
  line-height: 36px;
  outline: none;
}
.toolTipDiv span {
  display: flex;
    height: -webkit-fill-available;
    justify-content: center;
    align-items: center;
}
.toolTipDiv span label {
    display: flex;
    height: inherit;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
}
 
.el-tooltip__popper[x-placement^=bottom] .popper__arrow {
  left: 0px !important;
}

.smallCheck::after {
  height: 7px !important;
    left: 4px !important;
    top: 1px !important;
    border-right-width: 2px !important;
    border-bottom-width: 2px !important;
    width: 3px !important;
}
.largeCheck::after {
    height: 14px !important;
    left: 10px !important;
    top: 5px !important;
    border-right-width: 2px !important;
    border-bottom-width: 2px !important;
    width: 6px !important;
}
.ArticleSmall::after {
  height: 5px !important;
    left: 2px !important;
    top: 0px !important;
    border-right-width: 1px !important;
    border-bottom-width: 1px !important;
    width: 2px !important;
}
.ArticleLarge::after {
    height: 8px !important;
    left: 6.5px !important;
  top: 3px !important;
    border-right-width: 2px !important;
    border-bottom-width: 2px !important;
    width: 4px !important;
}
.smallStrip::after {
      height: 20px;
}
.mediumStrip::after {
      height: 28px;
}
.largeStrip::after {
    height: 36px;
}
.menuLable .el-checkbox {
  margin-right: 4px !important
}
/* Alert model popup arrow style */
.el-popper[x-placement^=bottom] .popper__arrow:first-of-type {
  display: none !important;
}
.el-popper[x-placement^=bottom] .popper__arrow{
  top: -18px !important;  
  margin-right: 3px !important;
  border-top-width: 0px !important;
  border-bottom-color: var(--grayLight) !important;
  display: block !important;
}
.el-popover.el-popper {
  margin-top: 24px !important;
  margin-left: -11px;
}
.el-select-dropdown.el-popper {
  margin-left: -10px;
  margin-top: 19px !important;
}
</style>
